export const adminOnboardingDestination = (companyId: string): string => `/company/${companyId}/admin-view`;
